// Ícones em SVG inline — sem dependências externas.
// Uso: <Icon name="juri" /> ou <Icon name="whatsapp" size={20} />

const traco = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const desenhos = {
  juri: (
    <g {...traco}>
      <path d="M12 4.5v15.5" />
      <path d="M7.5 20h9" />
      <path d="M4 7.5h16" />
      <path d="M12 3.2a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6" />
      <path d="M4 13.5 7 7.5l3 6a3 3 0 0 1-6 0Z" />
      <path d="M14 13.5 17 7.5l3 6a3 3 0 0 1-6 0Z" />
    </g>
  ),
  urgencia: (
    <g {...traco}>
      <circle cx="12" cy="13" r="8" />
      <path d="M12 8.5V13l3 1.8" />
      <path d="M9 2.5h6" />
    </g>
  ),
  patrimonio: (
    <g {...traco}>
      <rect x="3.5" y="10" width="17" height="10.5" rx="2" />
      <path d="M8 10V7.2a4 4 0 0 1 8 0V10" />
      <path d="M12 14v2.6" />
    </g>
  ),
  drogas: (
    <g {...traco}>
      <path d="M9.5 3h5" />
      <path d="M10.2 3v6.6L5.7 18a2 2 0 0 0 1.8 3h9a2 2 0 0 0 1.8-3l-4.5-8.4V3" />
      <path d="M7.6 15h8.8" />
    </g>
  ),
  domestica: (
    <g {...traco}>
      <path d="M3 10.8 12 3.2l9 7.6" />
      <path d="M5.6 9.6V20a1 1 0 0 0 1 1h10.8a1 1 0 0 0 1-1V9.6" />
      <path d="M10 21v-5h4v5" />
    </g>
  ),
  transito: (
    <g {...traco}>
      <path d="M4.5 17.2v-4.4l2.2-5.2A2 2 0 0 1 8.5 6.4h7a2 2 0 0 1 1.8 1.2l2.2 5.2v4.4" />
      <path d="M4.5 12.8h15" />
      <circle cx="8" cy="17.4" r="1.6" />
      <circle cx="16" cy="17.4" r="1.6" />
      <path d="M9.6 17.4h4.8" />
    </g>
  ),
  economicos: (
    <g {...traco}>
      <rect x="3" y="7.4" width="18" height="12.6" rx="2" />
      <path d="M8.6 7.4V6a2 2 0 0 1 2-2h2.8a2 2 0 0 1 2 2v1.4" />
      <path d="M3 12.8h18" />
      <path d="M11 12.8h2" />
    </g>
  ),
  digitais: (
    <g {...traco}>
      <rect x="3" y="4.2" width="18" height="12" rx="2" />
      <path d="M9 20h6" />
      <path d="M12 16.2V20" />
      <path d="M7.5 8.6 9.6 10.2 7.5 11.8" />
      <path d="M12.4 12h4" />
    </g>
  ),
  execucao: (
    <g {...traco}>
      <rect x="4" y="3.5" width="16" height="17" rx="1.5" />
      <path d="M9.3 3.5v17" />
      <path d="M14.7 3.5v17" />
      <path d="M4 12h16" />
    </g>
  ),
  recursos: (
    <g {...traco}>
      <path d="M14 3.2H7.4a2 2 0 0 0-2 2v13.6a2 2 0 0 0 2 2h9.2a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3.2V8h4.6" />
      <path d="M8.8 12.6h6.4" />
      <path d="M8.8 16.2h4" />
    </g>
  ),

  // --- interface ---
  menu: (
    <g {...traco}>
      <path d="M4 7h16" />
      <path d="M4 12h16" />
      <path d="M4 17h16" />
    </g>
  ),
  fechar: (
    <g {...traco}>
      <path d="M6 6l12 12" />
      <path d="M18 6 6 18" />
    </g>
  ),
  telefone: (
    <g {...traco}>
      <path d="M6.5 3.5h3l1.5 4-2 1.4a12 12 0 0 0 6.1 6.1l1.4-2 4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2Z" />
    </g>
  ),
  email: (
    <g {...traco}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3.6 6.5 7.2 5.6a2 2 0 0 0 2.4 0l7.2-5.6" />
    </g>
  ),
  local: (
    <g {...traco}>
      <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.6" />
    </g>
  ),
  relogio: (
    <g {...traco}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7v5.2l3.3 2" />
    </g>
  ),
  check: (
    <g {...traco}>
      <path d="m5 12.5 4.5 4.5L19 7.5" />
    </g>
  ),
  seta: (
    <g {...traco}>
      <path d="M5 12h13" />
      <path d="m12.5 6.5 5.5 5.5-5.5 5.5" />
    </g>
  ),
  chevron: (
    <g {...traco}>
      <path d="m6 9.5 6 6 6-6" />
    </g>
  ),
  instagram: (
    <g {...traco}>
      <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <path d="M16.9 7.1h.01" strokeWidth="2.2" />
    </g>
  ),
  linkedin: (
    <g {...traco}>
      <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="4" />
      <path d="M7.6 10.6V17" />
      <path d="M7.6 7.3h.01" strokeWidth="2.2" />
      <path d="M11.6 17v-3.4a2.5 2.5 0 0 1 5 0V17" />
      <path d="M11.6 10.6V17" />
    </g>
  ),
  whatsapp: (
    <path
      fill="currentColor"
      d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.91-7.01Zm-7.01 15.24h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.69 8.23-8.22 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.16.25-.64.81-.79.98-.14.16-.29.18-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.48c-.16 0-.43.06-.66.31-.22.25-.86.85-.86 2.06 0 1.22.89 2.39 1.01 2.56.12.16 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.47-.29Z"
    />
  ),
};

export default function Icon({ name, size = 24, className = '', ...rest }) {
  const desenho = desenhos[name];
  if (!desenho) return null;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      {desenho}
    </svg>
  );
}
